import React, { useState } from 'react'
import './style.sass'
import PropTypes from 'prop-types'
import { Collapse } from 'react-bootstrap'
import Arrow from '../../../assets/icons/arrow-right.svg'

const CustomCollapse = ({
  children,
  title,
  description,
  icon,
  isCollapsedDefault = true
}) => {
  const [isCollapsed, setIsCollapsed] = useState(isCollapsedDefault)

  return (
    <div className="custom-collapse-component-container">
      <header onClick={() => setIsCollapsed(collapsed => !collapsed)} className="custom-collapse-header">
          <div className="header-title-container">
              <h6>{title}</h6>
              {!icon || (
                <img src={icon} alt='icon' />
              )}
          </div>
          {isCollapsed ? (
            <object className='angle-up-icon' data={Arrow} type="image/svg+xml" aria-label="arrow" />
          ) : (
            <object className='angle-down-icon' data={Arrow} type="image/svg+xml" aria-label="arrow" />
          )}
      </header>
      <Collapse in={isCollapsed}> 
        <div className="custom-collapse-body">
          {!description || <p className="custom-collaps-description">{description}</p>}
          {children}
        </div>
      </Collapse>
    </div>
  )
}

CustomCollapse.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  icon: PropTypes.string,
  isCollapsedDefault: PropTypes.bool,
}

export default CustomCollapse
